import fetcher from '@/services/fetcher'
import { buildQueryV2 } from '@/utils/helpers'

const STORE_ADDRESS = `query StoreAddress {
  storeAddress {
    city
    city_id
    country_code
    description
    district
    district_id
    shipping_method
    email
    fax
    maps
    name
    postcode
    slider_id
    sort_description
    sort_order
    street
    telephone_1
    telephone_2
    ward
    ward_id
  }
}`

const fetchStoreAddress = async (options?: { locale?: string }) => {
  try {
    const response = await fetcher.get(buildQueryV2(STORE_ADDRESS), {
      next: { revalidate: 300, tags: ['list-store-address'] },
      cache: 'force-cache',
      locale: options?.locale,
    })
    const listStoreAddresses = response?.payload?.data?.storeAddress as TStoreAddress[]
    return listStoreAddresses
  } catch (err) {
    console.log(err)
    return undefined
  }
}

export { fetchStoreAddress }
